class UserPermission {
  // allows
  role;
  organisations;
  farms;
  orchards;

  populate(data) {
    // this.allows = data.allows || []
    this.role = data.role || '';
    this.orchards = data.orchards || [];
    this.farms = data.farms || [];
    this.organisations = data.organisations || [];
  }

  construct(data) {
    this.populate(data || {});
  }

  export() {
    return {
      role: this.role,
      organisations: this.organisations.map((o) => o.id),
      farms: this.farms.map((f) => f.id),
      orchards: this.orchards.map((o) => o.id)
    };
  }

  get isValid() {
    return (
      this.role !== '' &&
      ((this.organisations && this.organisations.length > 0) ||
        (this.farms && this.farms.length > 0) ||
        (this.orchards && this.orchards.length > 0))
    );
  }
}

export { UserPermission };
